import {useState} from 'react'
/** @jsxImportSource @emotion/react */
import {css} from '@emotion/react'

import {GridToolbarContainer, useGridApiContext} from '@mui/x-data-grid'

import {
  Button,
  Tooltip,
  TextField,
  IconButton,
  InputAdornment, 
} from '@mui/material'

import ClearIcon from '@mui/icons-material/Clear'
import FileDownloadIcon from '@mui/icons-material/FileDownload'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'

import {ReactComponent as MagnifyingGlassIcon} from '../../../svgs/MagnifyingGlass.svg'


const styles = {
  toolbarContainer: css`
    display: flex;
    justify-content: space-between;
    padding-bottom: 10px;
  `,
  saveButton: css`
    background: #000;
    color: #fff;
    font-size: 0.8rem;
    text-transform: none;
    padding: 8px 16px; 
    font-weight: 500;

    &:hover { 
      background: #000;
      box-shadow: none; 
    }
  `
}



function RSVPQuickFilter() {
  const apiRef = useGridApiContext()
  const [searchText, setSearchText] = useState('')

  const handleChange = (e) => {
    const v = e.target.value
    setSearchText(v)
    apiRef.current.setQuickFilterValues(v ? [v] : [])
  }
  const handleClear = () => {
    setSearchText('')
    apiRef.current.setQuickFilterValues([])
  }

  return (
    <TextField
      size='small'
      value={searchText}
      onChange={handleChange}
      variant='outlined'
      placeholder='Search…'
      InputProps={{
        startAdornment: (
          <InputAdornment position='start'>
            <MagnifyingGlassIcon height='18px' width='18px' />
          </InputAdornment>
        ),
        endAdornment: (
          <InputAdornment position='end'>
            <IconButton size='small' onClick={handleClear} sx={{visibility: 'visible'}}>
              <ClearIcon fontSize='small' />
            </IconButton>
          </InputAdornment>
        )
      }}
      sx={{
        minWidth: 270,
        '& .MuiOutlinedInput-root': {
          backgroundColor: '#F6F6F6',
          borderRadius: '24px',
          '& fieldset': { borderColor: '#d3d3d3', borderWidth: 1 },
          '&:hover fieldset': { borderColor: '#d3d3d3' },
          '&.Mui-focused fieldset': { borderColor: '#d3d3d3', borderWidth: 1 }
        },
        '& .MuiInputBase-input': { fontSize: '0.875rem' }
      }}
    />
  )
}


const RSVPCustomToolbar = ({ search, setSearch, onSend, onExport, sendDisabled }) => {
  return (
    <GridToolbarContainer css={styles.toolbarContainer}>
      <Button 
        css={styles.saveButton} 
        variant='outlined' 
        onClick={onSend} 
        disabled={sendDisabled}
        endIcon={
          <Tooltip title="This will send RSVPs to everyone below with a status of NOT SENT">
            <InfoOutlinedIcon fontSize='small' />
          </Tooltip>
        }
      >
        SEND RSVPS
      </Button>

      <div style={{ display: 'flex', gap: 12 }}>
        <Tooltip title="Download All RSVPs (CSV)">
          <IconButton onClick={onExport}>
            <FileDownloadIcon />
          </IconButton>
        </Tooltip>
        <RSVPQuickFilter />
      </div>
    </GridToolbarContainer>
  )
}

export default RSVPCustomToolbar


